import React from 'react'




function MessageBox({ username, message, time, type }) {
    return (
        <>
            <div className={`msg-box ${type !== "receive" ? "send" : "receive"}`}>
                {/* <div className="name">
                </div> */}
                <div className="msg">
                <strong> {type === "send"?
                "you" :username}</strong>
                    <p>{message}</p>
                </div>
            </div>
        </>
    )
}
export default MessageBox
